import axios from 'axios';
import React, { useState } from 'react';
import { BsSearch } from 'react-icons/bs';

//import { supabase } from "../../utils/supabase";

const PostcodeSearch = ({
  visibleData,
  onHide,
  onDataSorted,
  onPostcode,
  onCoordinates,
}) => {
  const [postcode, setPostcode] = useState('');

  const handleSearch = async () => {
    // Check if postcode is blank or only consists of whitespace
    if (!postcode.trim()) {
      alert('That is not a valid postcode. Please try again.');
      return; // Exit the function early if postcode is blank
    }

    try {
      // Fetch latitude & longitude from the postcode
      const response = await axios.get(
        `https://api.postcodes.io/postcodes/${postcode}`,
      );

      if (response.data && response.data.result) {
        const { latitude, longitude } = response.data.result;
        // Log the latitude and longitude to the console
        //console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);

        // Pass latitude and longitude to the parent (DataTable.js)
        if (typeof onCoordinates === 'function') {
          onCoordinates(latitude, longitude);
        }

        const distances = visibleData.map((course) => {
          return {
            name: course.course_name,
            distance: calculateDistance(
              latitude,
              longitude,
              course.latitude,
              course.longitude,
            ),
          };
        });
        //console.log(distances);

        // Sort distances
        const sortedDistances = distances.sort(
          (a, b) => a.distance - b.distance,
        );
        // After sorting the distances
        const sortedCourses = sortedDistances.map((d) => {
          const course = visibleData.find(
            (course) => course.course_name === d.name,
          );
          return {
            ...course,
            distance: d.distance,
          };
        });

        onDataSorted(sortedCourses);
        onPostcode(postcode);
        //console.log("sorted courses", sortedCourses);

        // Log the top 100 or fewer closest courses
        for (let i = 0; i < Math.min(100, sortedDistances.length); i++) {
          console.log(
            `${i + 1}. ${sortedDistances[i].name} - ${(
              sortedDistances[i].distance / 1000
            ).toFixed(2)} km`,
          );
        }
        onHide();
      }
    } catch (err) {
      // Handle specific error status inside the catch block
      if (err.response && err.response.status === 404) {
        alert('That is not a valid postcode. Please try again.');
      } else {
        console.error('Error fetching data from postcodes.io:', err);
      }
    }
  };

  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371e3; // radius of Earth in meters
    const φ1 = lat1 * (Math.PI / 180);
    const φ2 = lat2 * (Math.PI / 180);
    const Δφ = (lat2 - lat1) * (Math.PI / 180);
    const Δλ = (lon2 - lon1) * (Math.PI / 180);

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // in meters
  };

  return (
    <div className="mx-auto w-full grid grid-cols-3 gap-4">
      <div className="relative flex flex-row flex-nowrap justify-start items-center col-span-2">
        <BsSearch className="text-indigo-900 absolute left-2 top-1/2 transform -translate-y-1/2" />
        <input
          type="text"
          placeholder="Enter Postcode"
          value={postcode}
          onChange={(e) => setPostcode(e.target.value)}
          className="pl-8 border rounded p-1 my-1 w-full h-10" // Added padding-left (pl-6) to prevent text from overlapping with the icon
        />
      </div>
      <button
        onClick={handleSearch}
        className="flex justify-center items-center text-center rounded h-10 bg-green-600 p-4 text-white hover:bg-green-700 border border-white my-1"
      >
        Search
      </button>
    </div>
  );
};

export default PostcodeSearch;
